module.exports = __webpack_public_path__ + "assets/img/orders.81c340b6.svg";